import { FC } from 'react';
import CustomModal from 'components/custom-modal/CustomModal';
import { ServiceAreaInfo } from '../../jobs.model';
import { CircleCloseIcon, DropDownChevronDownIcon } from 'assets/icons';
import { ButtonType } from 'components/custom-button/CustomButton';
import { CustomButton, RadioWithLabel } from 'components';
import { metersToRoundedMiles } from 'utils/commonUtils';
import { selectCurrentTeamJobPermissions } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';

interface EditJobServiceAreaModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (serviceAreaId: string) => void;
  selectedAreaId?: string;
  jobNumber: string;
  serviceAreas: ServiceAreaInfo[];
  onCreateClick: () => void;
}

const EditJobServiceAreaModal: FC<EditJobServiceAreaModalProps> = ({
  isOpen,
  onClose,
  onSelect,
  selectedAreaId,
  jobNumber,
  serviceAreas,
  onCreateClick
}) => {
  const { editJobSettings } = useAppSelector(selectCurrentTeamJobPermissions);

  return (
    <CustomModal
      open={isOpen}
      closeModal={onClose}
      width="md:w-[510px]"
      height="h-auto"
      className="p-6"
      backgroundColor="bg-white">
      <div className="flex flex-col">
        <div className="relative mb-4 flex flex-col items-start justify-between">
          <div className="text-xl font-bold text-headingGray">Edit service area</div>
          <div className="mt-2 text-[15px] font-semibold text-gray-500">{jobNumber}</div>
          <CircleCloseIcon className="absolute right-0 top-0 cursor-pointer" onClick={onClose} />
        </div>

        <div className="custom-scrollbar flex flex-col divide-y overflow-y-auto md:max-h-[300px]">
          {editJobSettings && (
            <CustomButton
              className="w-full justify-start px-4 py-2 shadow-none"
              type={ButtonType.GHOST}
              childrenContainerStyles="text-17px"
              onClick={onCreateClick}
              id="create-service-area-button">
              + Create service area
            </CustomButton>
          )}
          {serviceAreas.map(area => (
            <div
              key={area.serviceAreaId}
              onClick={() => onSelect(area.serviceAreaId)}
              className="flex w-full cursor-pointer items-center justify-between p-3">
              <RadioWithLabel
                isSelected={selectedAreaId === area.serviceAreaId}
                labelStyle={{ width: '100%' }}
                containerClassname="w-full"
                label={
                  <div className="flex items-center text-base text-primaryText">
                    {area.serviceAreaName}
                    {area.distance > 0 && (
                      <div className="ml-1">
                        (
                        {area.isEnclosing
                          ? `within area, ${metersToRoundedMiles(area.distance)} miles away from center`
                          : `${metersToRoundedMiles(area.distance)} miles away`}
                        )
                      </div>
                    )}
                  </div>
                }
                onClick={() => null}
              />
              <div>
                <DropDownChevronDownIcon className="path path-fill-current h-[8px] w-[14px] -rotate-90 text-gray-1" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </CustomModal>
  );
};

export default EditJobServiceAreaModal;
